export default __webpack_public_path__ + "static/media/ChowMap.96e4da10.jpg";